import { render } from "./DeleteReport.vue?vue&type=template&id=21604140"
import script from "./DeleteReport.vue?vue&type=script&lang=js"
export * from "./DeleteReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__